import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[jhiAccessiblePopin]'
})
export class AccessiblePopinDirective implements OnInit, AfterViewInit, OnDestroy {

    @Input() ariaLabelledby: string;
    @Input() ariaDescribedby: string;

    activeElement: Element;

    constructor(private elementRef: ElementRef) { }

    ngOnInit() {
        this.activeElement = document.activeElement;
    }

    ngAfterViewInit() {
        const modalEl = this.elementRef.nativeElement.closest('ngb-modal-window');

        if (!modalEl) {
            return;
        }


        modalEl.setAttribute('aria-labelledby', this.ariaLabelledby);
        modalEl.setAttribute('aria-describedby', this.ariaDescribedby);
        modalEl.setAttribute('aria-modal', 'true');

        document.getElementsByTagName('ngb-modal-backdrop')[0].setAttribute('aria-hidden', 'true');
        document.getElementById('jhi-main').setAttribute('aria-hidden', 'true');

        const focusableEls = modalEl.querySelectorAll('button');
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];

        firstFocusableEl.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' && event.shiftKey === true) {
                event.preventDefault();
                lastFocusableEl.focus();
            }
        });
        lastFocusableEl.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' && event.shiftKey === false) {
                event.preventDefault();
                firstFocusableEl.focus();
            }
        });

        firstFocusableEl.focus({ preventScroll: true });
    }

    ngOnDestroy() {
        document.getElementById('jhi-main').removeAttribute('aria-hidden');
        if (this.activeElement) { (this.activeElement as HTMLElement).focus(); }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/accessible-popin.directive.ts